<!--
 * @Author: Gaho
 * @Date: 2024-01-15 09:49:50
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-27 11:08:26
 * @Description: 
-->
<template>
    <div class="flex sm:items-start w-full justify-end sm:flex-col gap-2 gmd:flex-row mb-2 button-settings">
        <div class="flex gap-[5px] w-full gmd:w-auto ">
            <slot></slot>
        </div>
    </div>
</template>
